import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './components/Layout/MainLayout';
import Home from './pages/Home';
import Insights from './pages/Insights';
import Gamification from './pages/Gamification';
import Applications from './pages/Applications';
import Payments from './pages/Payments';
import Settings from './pages/Settings';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainLayout title="Home"><Home /></MainLayout>} />
        <Route path="/insights" element={<MainLayout title="Insights"><Insights /></MainLayout>} />
        <Route path="/gamification" element={<MainLayout title="Gamification"><Gamification /></MainLayout>} />
        <Route path="/applications" element={<MainLayout title="Applications"><Applications /></MainLayout>} />
        <Route path="/payments" element={<MainLayout title="Payments"><Payments /></MainLayout>} />
        <Route path="/settings" element={<MainLayout title="Settings"><Settings /></MainLayout>} />
      </Routes>
    </Router>
  );
}

export default App;
